import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_TASKS_ACTION_TYPE } from '../actions';

const TASKS_LOAD_ERROR_MESSAGE = 'Failed to load tasks.';

const initialState = { loading: false, error: null };

const subCompanyTasksStatusReducer = (state = initialState, { type }) =>
  produce(state, draft => {
    switch (type) {
      case SUB_COMPANY_TASKS_ACTION_TYPE.GET_TASKS_REQUEST:
        draft.loading = true;
        draft.error = null;
        break;

      case SUB_COMPANY_TASKS_ACTION_TYPE.GET_TASKS:
        draft.loading = false;
        draft.error = null;
        break;

      case SUB_COMPANY_TASKS_ACTION_TYPE.GET_TASKS_FAILURE:
        draft.loading = false;
        draft.error = TASKS_LOAD_ERROR_MESSAGE;
        break;

      case SUB_COMPANY_TASKS_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyTasksStatusReducer;
